import { inRange } from 'lodash';

import { TypographyVariants } from '@lyearn/ui';

enum States {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  NotApplicable = 'notapplicable',
}

const stateRanges: Record<Exclude<States, States.NotApplicable>, Record<string, number>> = {
  [States.Success]: {
    start: 4,
    end: 5,
  },
  [States.Warning]: {
    start: 2,
    end: 3,
  },
  [States.Error]: {
    start: -1,
    end: 1,
  },
};

// Note: This is also used here - app/modules/report/views/ReportEditor/components/ReportTableChart/components/MetricScoreCell/utils.ts
// Make sure to update there if necessary
export function getStateFromScore(score: number | undefined | null): string | undefined {
  if (score === null || score === undefined) {
    return States.NotApplicable;
  }

  const roundedDownScore = Math.floor(score);
  for (const [state, range] of Object.entries(stateRanges)) {
    if (inRange(roundedDownScore, range.start, range.end + 1)) {
      return state;
    }
  }
}

enum PropertyType {
  Background = 'bg',
  Border = 'border',
  Content = 'text',
  Variant = 'variant',
}

const propertyStateColorMap = {
  [PropertyType.Background]: {
    [States.Success]: 'bg-bg-success-light',
    [States.Warning]: 'bg-bg-warning-light',
    [States.Error]: 'bg-bg-error-light',
    [States.NotApplicable]: 'bg-interactive-bg-hover',
  },
  [PropertyType.Border]: {
    [States.Success]: 'border-border-success',
    [States.Warning]: 'border-border-warning-dark',
    [States.Error]: 'border-border-error-dark',
    [States.NotApplicable]: 'border-border-dark',
  },
  [PropertyType.Content]: {
    [States.Success]: 'text-text-success',
    [States.Warning]: 'text-text-warning',
    [States.Error]: 'text-text-error',
    [States.NotApplicable]: 'text-text-placeholder',
  },
  [PropertyType.Variant]: {
    [States.Success]: 'heading-xxs',
    [States.Warning]: 'heading-xxs',
    [States.Error]: 'heading-xxs',
    [States.NotApplicable]: 'heading-xxs',
  },
};

function getColorsFromState(state?: States): {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  variant: TypographyVariants;
} {
  return {
    backgroundColor: propertyStateColorMap[PropertyType.Background][state!],
    borderColor: propertyStateColorMap[PropertyType.Border][state!],
    textColor: propertyStateColorMap[PropertyType.Content][state!],
    variant: propertyStateColorMap[PropertyType.Variant][state!] as TypographyVariants,
  };
}

export function getColors(score: number | undefined | null) {
  const state = getStateFromScore(score);
  return getColorsFromState(state as States);
}
